export default "__VITE_ASSET__DBox3o9i__"